import {
  BriefcaseBusiness,
  Shield,
  Tickets,
  Trophy,
  Users,
} from "lucide-react";

export const menuData = {
  menu: [
    {
      label: "Campeonatos",
      icon: <Trophy size={20} />,
      url: "/championships",
    },
    {
      label: "Eventos",
      icon: <Tickets size={20} />,
      url: "/events/",
    },

    {
      label: "Minhas Equipes",
      icon: <Shield size={20} />,
      url: "/teams",
    },
    {
      label: "Vagas ",
      icon: <BriefcaseBusiness size={20} />,
      url: "/jobs",
    },
    {
      label: "Players",
      icon: <Users size={20} />,
      url: "/players",
    },

  ],
};
